export default __webpack_public_path__ + "static/media/2336.eb104823.png";